/*
 * @Author: kevinqq 350910378@qq.com
 * @Date: 2025-03-17 15:11:05
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-18 12:04:38
 * @FilePath: \baishu_react_ui\src\components\BsyGuide\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import BsyIconBtn from "../BsyIconBtn";
import "./index.css";

export default function BsyMyAppGuide(props) {
  return (
    <div
      className="bsy-my-app-guide-bg"
      style={{
        backgroundImage: `url(/template/resource/images/myAppGuide.png)`,
        backgroundSize: "100% 100%",
      }}
    >
      <div className="bsy-my-app-guide-content-btn">
        <BsyIconBtn
          text={React.language("iSee")}
          click={props?.onClose}
          type="blue"
        ></BsyIconBtn>
      </div>
      <div className="bsy-my-app-guide-close" onClick={props?.onClose}>
        <i className="icon-bsy-error-tip"></i>
      </div>
    </div>
  );
}
